'use client';

import React from 'react';

/**
 * Neutral, unbranded landing page.
 *
 * This app is meant to be embedded (as an iframe) and entered through
 * per-participant invite links (`/j/<code>`). The standalone home page
 * intentionally does NOT let anyone create or join rooms. It only offers a
 * "Back" action which signals the embedding parent window to close the iframe.
 */
export default function Page() {
  const handleClose = React.useCallback(() => {
    // Tell the parent app (which embeds us in an iframe) to close the iframe.
    try {
      if (typeof window !== 'undefined' && window.parent && window.self !== window.top) {
        window.parent.postMessage({ type: 'meet:close' }, '*');
        return;
      }
    } catch {
      /* cross-origin access can throw — fall through */
    }
    // Not embedded: best-effort go back.
    if (typeof window !== 'undefined' && window.history.length > 1) {
      window.history.back();
    }
  }, []);

  return (
    <main
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'radial-gradient(1200px 600px at 50% -10%, #1b1b20 0%, #0a0a0c 60%)',
        color: '#e7e7ea',
        padding: '24px',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 380,
          textAlign: 'center',
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: 20,
          padding: '40px 28px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.45)',
          backdropFilter: 'blur(6px)',
        }}
      >
        <div
          aria-hidden
          style={{
            width: 64,
            height: 64,
            margin: '0 auto 20px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(99,102,241,0.15)',
            border: '1px solid rgba(99,102,241,0.35)',
          }}
        >
          {/* simple video glyph, unbranded */}
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#a5b4fc" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M23 7l-7 5 7 5V7z" />
            <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
          </svg>
        </div>

        <h1 style={{ fontSize: '1.25rem', fontWeight: 600, margin: '0 0 8px' }}>
          You&apos;re all set
        </h1>
        <p style={{ fontSize: '0.9rem', lineHeight: 1.5, color: '#9a9aa2', margin: '0 0 28px' }}>
          There&apos;s nothing to do here. Open a meeting from your invitation link to join.
        </p>

        <button
          onClick={handleClose}
          style={{
            width: '100%',
            padding: '12px 16px',
            fontSize: '0.95rem',
            fontWeight: 600,
            color: '#fff',
            background: 'linear-gradient(180deg, #6366f1 0%, #4f46e5 100%)',
            border: 'none',
            borderRadius: 12,
            cursor: 'pointer',
          }}
        >
          ← Back
        </button>
      </div>
    </main>
  );
}
